import { AbstractControl, ValidationErrors } from '@angular/forms';

export function rabatValidator(formGroup: AbstractControl): ValidationErrors {
  if (!formGroup.get('rabatEnabled') || formGroup.get('rabatEnabled').value == false) {
    return null;
  }

  if (!formGroup.get('rabatKontant') && !formGroup.get('rabatProcent')) {
    return null;
  }

  const rabatNotSet = !formGroup.get('rabatKontant').value && !formGroup.get('rabatProcent').value;
  if (rabatNotSet) {
    return { rabat: 'Rabat skal udfyldes enten som procent eller som kontant' };
  }

  const rabatBothSet = formGroup.get('rabatKontant').value && formGroup.get('rabatProcent').value;
  return rabatBothSet ? { rabat: 'Rabat kan ikke indtastes som både kontant og procent' } : null;
}
